/**
 * TierBadge — Tier pill for free / drama_plus / dramax.
 *
 * Contrast:
 *   drama_plus: #7C3AED on #EDE9FE = 6.1:1 (AA)
 *   dramax:     #E9D5FF on #1F1B3A = 12.4:1 (AAA)
 *   free:       #374151 on #F3F4F6 = 8.3:1 (AAA)
 *
 * Candidate for promotion to packages/ui after this screen ships.
 */

import React from 'react';
import { Text, View, StyleSheet } from 'react-native';
import type { TFunction } from '@dramadetector/shared';

type Tier = 'free' | 'drama_plus' | 'dramax';

interface TierBadgeProps {
  tier: Tier;
  t: TFunction<'practitioner'>;
}

const TIER_CONFIG: Record<Tier, { bg: string; text: string; labelKey: string }> = {
  free:       { bg: '#F3F4F6', text: '#374151', labelKey: 'tier.free' },
  drama_plus: { bg: '#EDE9FE', text: '#7C3AED', labelKey: 'tier.drama_plus' },
  dramax:     { bg: '#1F1B3A', text: '#E9D5FF', labelKey: 'tier.dramax' },
};

export const TierBadge: React.FC<TierBadgeProps> = ({ tier, t }) => {
  const config = TIER_CONFIG[tier];

  return (
    <View style={[styles.badge, { backgroundColor: config.bg }]}>
      <Text style={[styles.text, { color: config.text }]}>
        {t(config.labelKey as never)}
      </Text>
    </View>
  );
};

const styles = StyleSheet.create({
  badge: {
    paddingHorizontal: 8,
    paddingVertical: 2,
    borderRadius: 9999,
    alignSelf: 'center',
  },
  text: {
    fontSize: 11,
    fontWeight: '700',
  },
});
